module.exports = __webpack_public_path__ + "static/media/wes-01.3c73540e.jpg";